import { Provider as MicrofrontendProvider } from '@cian/mf-react';
import { UiKitContextProvider, UiKitToastsContextProvider } from '@cian/ui-kit';
import * as React from 'react';
import { Provider } from 'react-redux';
import { Store } from 'redux';

import { ErrorBoundary } from '../../components/ErrorBoundary';
import { IApplicationContext } from '../../types/applicationContext';
import { EDeviceType } from '../../types/deviceType';
import { EHostType } from '../../types/hostType';
import { ApplicationContext } from '../../utils/applicationContext';
import { DailyrentModalProvider } from '../../utils/dailyrent/useDailyrentModal';
import { PageContainer } from '../PageContainer';
import { ChatsLinkActions } from '../ChatsLinkActions';

export interface IApplicationProps {
  context: IApplicationContext;
  store: Store;
}

export const AppContainer: React.FC<IApplicationProps> = ({ store, context }) => {
  const {
    custom: { realDevice, hostType },
    microfrontendsRegistry,
    logger,
    telemetry,
  } = context;
  const device = realDevice === EDeviceType.Desktop && hostType === EHostType.Frame ? EDeviceType.Phone : realDevice;

  return (
    <ApplicationContext.Provider value={context}>
      <UiKitContextProvider deviceType={device} useStaticDeviceType>
        <UiKitToastsContextProvider>
          <MicrofrontendProvider registry={microfrontendsRegistry}>
            <Provider store={store}>
              <DailyrentModalProvider>
                <ErrorBoundary logger={logger} telemetry={telemetry}>
                  <ChatsLinkActions />
                  <PageContainer />
                </ErrorBoundary>
              </DailyrentModalProvider>
            </Provider>
          </MicrofrontendProvider>
        </UiKitToastsContextProvider>
      </UiKitContextProvider>
    </ApplicationContext.Provider>
  );
};
